import { useEffect } from 'react';
import findLast from 'lodash/findLast';
import last from 'lodash/last';
import type {
	DeploymentFrequencyReportWeekData,
	DeploymentFrequencyReportWithProviderInfo,
} from '../../common/types.tsx';
import type { actions } from './index.tsx';

export const getSelectedWeekData = (
	weeksData: DeploymentFrequencyReportWeekData[],
	selectedWeekStartDate: Date,
): DeploymentFrequencyReportWeekData => {
	const foundWeekData = weeksData.find(
		(weekData: DeploymentFrequencyReportWeekData) =>
			weekData.startDateInclusive.getTime() === selectedWeekStartDate.getTime(),
	);

	if (foundWeekData === undefined) {
		throw new Error('Could not find the selected week data for the given selected date range');
	}

	return foundWeekData;
};

export const useSmartWeekSelect = (
	data: DeploymentFrequencyReportWithProviderInfo | null | undefined,
	selectedWeekStart: Date | null,
	setSelectedWeekStart: typeof actions.setSelectedWeekStart,
) => {
	useEffect(() => {
		if (data != null) {
			const selectLatestWeekWithDataNotCurrentWeek = () => {
				const selectedWeekData = findLast(
					data.weeksData,
					(weekData) => weekData.deploymentCount.prod,
					data.weeksData.length - 2,
				);

				if (selectedWeekData) {
					// @ts-expect-error - TS2339 - Property 'startDateInclusive' does not exist on type 'number | DeploymentFrequencyReportWeekData | { <S extends DeploymentFrequencyReportWeekData>(predicate: (value: DeploymentFrequencyReportWeekData, index: number, array: DeploymentFrequencyReportWeekData[]) => value is S, thisArg?: any): this is S[]; (predicate: (value: DeploymentFrequencyReportWeekData, index: numbe...'.
					setSelectedWeekStart(selectedWeekData.startDateInclusive);
				} else {
					// if we can't find any week with data, select the current week
					// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
					setSelectedWeekStart(last(data.weeksData).startDateInclusive);
				}
			};

			if (
				selectedWeekStart === null ||
				getSelectedWeekData(data.weeksData, selectedWeekStart).deploymentCount.prod === 0
			) {
				selectLatestWeekWithDataNotCurrentWeek();
			}
		}
	}, [data, selectedWeekStart, setSelectedWeekStart]);
};
